export const Config = {
  baseFolder: '',
  apiRoot: 'https://amss.normasoft.net/api/v1/',
  protectionOff: false
};
